function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M34.313 60.745c16.136 0 28.435-16.649 25.154-33.958C54.821 2.275 43.731.745 27.595.745 11.46.745 1.971 10.664.063 32.592c-1.308 15.028 18.115 28.153 34.25 28.153z",
  fill: "#fef0f1"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 20.745l10 10-10 10",
  stroke: "#8781bd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 61,
    width: 60
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYxIiB2aWV3Qm94PSIwIDAgNjAgNjEiIHdpZHRoPSI2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzQuMzEzMyA2MC43NDQ2YzE2LjEzNTYgMCAyOC40MzQ5LTE2LjY0ODQgMjUuMTUzOS0zMy45NTcyLTQuNjQ2NC0yNC41MTI3My0xNS43MzY1LTI2LjA0Mjc2OS0zMS44NzIxLTI2LjA0Mjc3LTE2LjEzNTUtLjAwMDAwMS0yNS42MjQ1NyA5LjkxOTM3LTI3LjUzMjQ3NzQgMzEuODQ2OTctMS4zMDc1ODI2IDE1LjAyOCAxOC4xMTUwNzc0IDI4LjE1MyAzNC4yNTA2Nzc0IDI4LjE1M3oiIGZpbGw9IiNmZWYwZjEiLz48cGF0aCBkPSJtMjcgMjAuNzQ0NiAxMCAxMC0xMCAxMCIgc3Ryb2tlPSIjODc4MWJkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==";
export { SvgRight as ReactComponent };